define('casino/jackpots',['jquery', 'casino/casino', 'casino/casino-data', 'all/navigation', 'all/interval-manager'], function($, casino, casinoData, navigation, IntervalManager) {
	'use strict';

	var initialized = false;
	var $jackpots;
	var $highJackpots;
	var $moreJackpots;
	var $jackpotTicker;

	function initStartPageSlider() {
		$jackpotTicker = $('#jackpot');
		$jackpotTicker.populate(casinoData.highJackpots).scroller();
	}

	function populateJackpotElements() {
		$jackpots.find('#total-jackpot-sum').text(casinoData.jackpotSum);

		$highJackpots.populate(casinoData.highJackpots);
		$moreJackpots.populate(casinoData.moreJackpots);
	}

	function updateJackpotElements() {
		$jackpots.find('#total-jackpot-sum').text(casinoData.jackpotSum);

		$('.badge-jackpot,#jackpot .content h2,#high-jackpots h2').each(function() {
			var $game = $(this).parents('section').first();
			var id = $game.data('game');
			var game = casino.getMatchingGame(id);
			if(game && game.jackpot) {
				$(this).text(game.jackpot);
			}
		});
	}

	function init() {
		if (initialized) {
			return;
		}
		initialized = true;

		$jackpots = $('#casino-jackpots');
		$highJackpots = $jackpots.find('#high-jackpots');
		$moreJackpots = $jackpots.find('#more-jackpots');

		// TODO: better id for the ticker, double check CSS etc
		$jackpotTicker = $('#jackpot');

		populateJackpotElements();
		IntervalManager.setInterval(updateJackpotElements, 2 * IntervalManager.MINUTES);
	}

	var jackpots = {
		init: init,
		initStartPageSlider: initStartPageSlider
	};

	return jackpots;
});

